import React from 'react';
import { ChangeEvent } from 'react';
import styled from 'styled-components';

const StyledInput = styled.input<{ dark: boolean }>`
  height: 70px;
  width: 100%;
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.background.primary};
  font-family: Manrope;
  font-size: 16px;
  font-weight: 500;
  color: ${({ disabled, theme }) =>
    disabled ? `${theme.text.secondary}` : `${theme.text.regular}`};
  margin-top: 16px;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary.accent};
    padding: 24px;
  }
  ${({ dark }) =>
    dark && `border: 1px solid ${({ theme }) => theme.text.secondary}`}
`;

interface TextInputProps {
  dark?: boolean;
  label?: string;
  value: string;
  type?: string;
  error?: string;
  tooltip?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  maxValue?: number;
}

const InputContainer = styled.div`
  display: flex;
  width: fit-content;
  max-width: 719px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 12px;
  &:focus-within {
    .label {
      color: ${({ theme }) => theme.primary.accent};
    }
  }
`;

export const Label = styled.p<{ dark: boolean }>`
  font-family: Manrope;
  color: ${({ dark }) =>
    dark
      ? `${({ theme }) => theme.text.secondary}`
      : `${({ theme }) => theme.text.primary}`};
  font-size: 12px;
  font-weight: 400;
`;

const MaxLabel = styled.p<{ dark: boolean }>`
  font-family: Manrope;
  color: ${({ theme }) => theme.primary.accent};
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
`;

export const ErrorLabel = styled.p`
  margin-top: 5px;
  font-family: Manrope;
  color: ${({ theme }) => theme.status.error.primary};
  font-size: 12px;
  font-weight: 400;
  &::first-letter {
    text-transform: uppercase;
  }
`;

const LabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const VetsTextInput = ({
  type = 'text',
  label,
  value,
  onChange,
  onBlur,
  error,
  dark = false,
  disabled,
  maxValue,
}: TextInputProps) => {
  return (
    <>
      <InputContainer>
        <LabelsContainer>
          {label && (
            <Label dark={dark} className='label'>
              {label}&nbsp;
            </Label>
          )}
          {!!maxValue && (
            <MaxLabel
              dark={dark}
              className='label'
              onClick={() => {
                onChange(String(maxValue));
              }}
            >
              MAX
            </MaxLabel>
          )}
        </LabelsContainer>
        <StyledInput
          disabled={disabled}
          dark={dark}
          type={type}
          onBlur={onBlur}
          className='input'
          value={value}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onChange(event.target.value)
          }
        />
        {error && <ErrorLabel>{error}</ErrorLabel>}
      </InputContainer>
    </>
  );
};

export default VetsTextInput;
